import React from 'react';
import { string } from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import classNames from 'classnames';
import { twitterPageURL } from '../../util/urlHelpers';
import config from '../../config';
import {
  IconSocialMediaFacebook,
  IconSocialMediaInstagram,
  IconSocialMediaTwitter,
  Logo,
  ExternalLink,
  NamedLink,
} from '../../components';

import css from './Footer.module.css';
import IconSocialMediaTiktok from '../IconSocialMediaTiktok/IconSocialMediaTiktok';

const renderSocialMediaLinks = intl => {
  const { siteFacebookPage, siteInstagramPage, siteTwitterHandle, siteTiktokPage } = config;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);

  const goToFb = intl.formatMessage({ id: 'Footer.goToFacebook' });
  const goToInsta = intl.formatMessage({ id: 'Footer.goToInstagram' });
  const goToTwitter = intl.formatMessage({ id: 'Footer.goToTwitter' });
  const goToTikTok = intl.formatMessage({ id: 'Footer.goToTikTok' });

  const fbLink = siteFacebookPage ? (
    <ExternalLink key="linkToFacebook" href={siteFacebookPage} className={css.icon} title={goToFb}>
      <IconSocialMediaFacebook />
    </ExternalLink>
  ) : null;

  const twitterLink = siteTwitterPage ? (
    <ExternalLink
      key="linkToTwitter"
      href={siteTwitterPage}
      className={css.icon}
      title={goToTwitter}
    >
      <IconSocialMediaTwitter />
    </ExternalLink>
  ) : null;

  const instragramLink = siteInstagramPage ? (
    <ExternalLink
      key="linkToInstagram"
      href={siteInstagramPage}
      className={css.icon}
      title={goToInsta}
    >
      <IconSocialMediaInstagram />
    </ExternalLink>
  ) : null;
  const tiktokLink = siteInstagramPage ? (
    <ExternalLink key="linkToTikTok" href={siteTiktokPage} className={css.icon} title={goToTikTok}>
      <IconSocialMediaTiktok />
    </ExternalLink>
  ) : null;
  return [fbLink, twitterLink, tiktokLink, instragramLink].filter(v => v != null);
};

const Footer = props => {
  const { rootClassName, className, intl } = props;
  const socialMediaLinks = renderSocialMediaLinks(intl);
  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <div className={css.topBorderWrapper}>
        <div className={css.content}>
          <div className={css.someLiksMobile}>{socialMediaLinks}</div>
          <div className={css.links}>
            <div className={css.organization} id="organization">
              {/* <NamedLink name="LandingPage" className={css.logoLink}>
                <Logo format="desktop" className={css.logo} />
              </NamedLink> */}
              <div className={css.organizationInfo}>
                <p className={css.organizationDescription}>
                  <FormattedMessage id="Footer.organizationDescription" />
                </p>
                <p className={css.organizationCopyright}>
                  <NamedLink name="LandingPage" className={css.copyrightLink}>
                    <FormattedMessage id="Footer.copyright" />
                  </NamedLink>
                </p>
              </div>
            </div>
            <div className={css.infoLinks}>
              <ul className={css.list}>
                <li className={css.listItem}>
                  <NamedLink name="NewListingPage" className={css.link}>
                    List an Item
                  </NamedLink>
                </li>
                <li className={css.listItem}>
                  <a className={css.link} href="/p/selltotutulist">
                    Ways to Sell
                  </a>
                </li>
                <li className={css.listItem}>
                  <a className={css.link} href="/p/encore-envelope">
                    Encore Envelopes
                  </a>
                </li>
                <li className={css.listItem}>
                  <a
                    className={css.link}
                    href="https://support.tutulist.com/hc/en-us/categories/10436045187213-Sell"
                  >
                    Seller FAQ
                  </a>
                </li>
                <li className={css.listItem}>
                  <a
                    className={css.link}
                    href="https://support.tutulist.com/hc/en-us/categories/10436054867853-Buy"
                  >
                    Buyer FAQ
                  </a>
                </li>
              </ul>
            </div>
            <div className={css.searches}>
              <ul className={css.list}>
                <li className={css.listItem}>
                  <NamedLink name="SearchPage" className={css.link}>
                    Shop
                  </NamedLink>
                </li>
                <li className={css.listItem}>
                  <NamedLink
                    name="SearchPage"
                    to={{
                      search: '?pub_category=dancewear',
                    }}
                    className={css.link}
                  >
                    Dancewear
                  </NamedLink>
                </li>
                <li className={css.listItem}>
                  <NamedLink
                    name="SearchPage"
                    to={{ search: '?pub_category=dancewear&pub_type=Leotard' }}
                    className={css.link}
                  >
                    Leotards
                  </NamedLink>
                </li>
                <li className={css.listItem}>
                  <NamedLink
                    name="SearchPage"
                    to={{ search: '?pub_category=dancewear&pub_type=Warmups' }}
                    className={css.link}
                  >
                    Warmups
                  </NamedLink>
                </li>
                <li className={css.listItem}>
                  <NamedLink
                    name="SearchPage"
                    to={{ search: '?pub_category=dancewear&pub_type=Contemporary' }}
                    className={css.link}
                  >
                    Contemporary
                  </NamedLink>
                </li>
                <li className={css.listItem}>
                  <NamedLink name="CostumeSearchPage" className={css.link}>
                    Costumes
                  </NamedLink>
                </li>
              </ul>
            </div>
            <div className={css.searchesExtra}>
              <ul className={css.list}>
                <li className={css.listItem}>
                  <a className={css.link} href="/p/about">
                    About Us
                  </a>
                </li>
                <li className={css.listItem}>
                  <a className={css.link} href="https://support.tutulist.com/hc/en-us">
                    Help Center
                  </a>
                </li>
                <li className={css.listItem}>
                  <a className={css.link} href="/contact">
                    <FormattedMessage id="Footer.toContactPage" />
                  </a>
                </li>
                <li className={css.listItem}>
                  <a
                    className={css.link}
                    href="https://support.tutulist.com/hc/en-us/articles/13914185704077-Safety-and-Community-on-Tutulist"
                  >
                    Community Guidelines
                  </a>
                </li>
                <li className={css.listItem}>
                  <a className={css.link} href="/p/terms-of-service">
                    <FormattedMessage id="Footer.termsOfUse" />
                  </a>
                </li>
                <li className={css.listItem}>
                  <a className={css.link} href="/p/privacy-policy">
                    <FormattedMessage id="Footer.privacyPolicy" />
                  </a>
                </li>
              </ul>
            </div>
            <div className={css.extraLinks}>
              <div className={css.someLinks}>{socialMediaLinks}</div>
              <div className={css.legalMatters}>
                {/* <ul className={css.tosAndPrivacy}>
                  <li>
                    <NamedLink name="TermsOfServicePage" className={css.legalLink}>
                      <FormattedMessage id="Footer.termsOfUse" />
                    </NamedLink>
                  </li>
                  <li>
                    <NamedLink name="PrivacyPolicyPage" className={css.legalLink}>
                      <FormattedMessage id="Footer.privacyPolicy" />
                    </NamedLink>
                  </li>
                </ul> */}
              </div>
            </div>
          </div>
          <div className={css.copyrightAndTermsMobile}>
            <NamedLink name="LandingPage" className={css.organizationCopyrightMobile}>
              <FormattedMessage id="Footer.copyright" />
            </NamedLink>
            {/* <div className={css.tosAndPrivacyMobile}>
              <NamedLink name="PrivacyPolicyPage" className={css.privacy}>
                <FormattedMessage id="Footer.privacy" />
              </NamedLink>
              <NamedLink name="TermsOfServicePage" className={css.terms}>
                <FormattedMessage id="Footer.terms" />
              </NamedLink>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

Footer.defaultProps = {
  rootClassName: null,
  className: null,
};

Footer.propTypes = {
  rootClassName: string,
  className: string,
  intl: intlShape.isRequired,
};

export default injectIntl(Footer);
